import { Edit, useRecordContext, useTranslate } from 'react-admin';
import { useDuplicateNotify } from 'hooks';
import LanguageLevelForm from './LanguageLevelForm';

const LanguageLevelTitle = () => {
  const record = useRecordContext();
  const translate = useTranslate();
  const label = translate('resources.language_levels.name', { smart_count: 1 });

  return `${label}: ${record.level}`;
};

const LanguageLevelEdit = () => {
  const notify = useDuplicateNotify();

  return (
    <Edit title={<LanguageLevelTitle />} mutationOptions={{ onError: notify }}>
      <LanguageLevelForm />
    </Edit>
  );
};

export default LanguageLevelEdit;
